export default {
  showToast: false,
  toastText: '',
}
